import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
/**
 * 邮箱之前的字符
 * 例子{{data.name | stringPi}}
 * 注意：需要在使用的module导入StringPiPipe
 */
@Pipe({
    name: 'stringPi',
})
export class StringPiPipe implements PipeTransform {
    transform(value: any): any {
        if(value){
            return value.indexOf('#') > 0 ? value.substr(0,value.indexOf('#')):  (value.indexOf('@') > 0 ?   value.substr(0,value.indexOf('@')) : value);
        }
        return ""

        }
}

@Pipe({
    name: 'linebreaks'
  })
  export class LinebreaksPipe implements PipeTransform {

    transform(text: any): any {
        if(text){
            return text.replace(/\n/g, "<br>");
        }
            return "";
        }
  }

/**
 * Custom UTC Date Pipe - Converts UTC datetime string to local time
 * Usage: {{ dateValue | utcDate:'dd/MM/yyyy HH:mm' }}
 */
@Pipe({
    name: 'utcDate'
  })
  export class UtcDatePipe implements PipeTransform {
    private datePipe: DatePipe;

    constructor() {
        this.datePipe = new DatePipe('en-US');
    }

    transform(value: any, format: string = 'dd/MM/yyyy HH:mm'): any {
        if (!value) return '';

        // If it's already a Date object, use it directly
        if (value instanceof Date) {
            return this.datePipe.transform(value, format);
        }

        // If it's a string, parse it as UTC
        // Handle ISO format: 2025-12-30T02:02:00Z or 2025-12-30T02:02:00
        let date: Date;

        if (typeof value === 'string') {
            // If string has 'Z' or timezone info, JavaScript will parse it as UTC
            if (value.includes('Z') || value.includes('+') || (value.includes('-') && value.length > 10)) {
                date = new Date(value);
            } else {
                // If no timezone info, treat as UTC by appending 'Z'
                date = new Date(value + 'Z');
            }
        } else {
            date = new Date(value);
        }

        if (isNaN(date.getTime())) {
            return value; // Return original if invalid date
        }

        return this.datePipe.transform(date, format);
    }
  }
